const allowedRoles = ["admin"];
export default [
  {
    path: "/admin/communications/:communicationId",
    component: () =>
      import(
        /* webpackChunkName: "communication" */ "@/views/admin/communication/SingleCommunication/Edit.vue"
      ),
    meta: {
      breadcrumbs: [
        {
          link: "/admin/communications",
          title: "Communications"
        }
      ],
      pageTitle: "Communication",
      requireAuth: true,
      allowedRoles
    }
  },
  {
    path: "/admin/communications",
    component: () =>
      import(
        /* webpackChunkName: "communication" */ "@/views/admin/communication/ListCommunications/ListCommunications.vue"
      ),
    meta: {
      pageTitle: "Communications",
      title: "Communications",
      requireAuth: true,
      allowedRoles,
      metaTags: {
        title: "Communications"
      }
    }
  },
  {
    path: "/admin/communications/:communicationId/completed",
    component: () =>
      import(
        /* webpackChunkName: "communication" */ "@/views/admin/communication/SingleCommunicationDispatched/CommunicationDispatched.vue"
      ),
    meta: {
      breadcrumbs: [
        {
          link: "/admin/communications",
          title: "Communications"
        }
      ],
      pageTitle: "Communication",
      requireAuth: true,
      allowedRoles,
      metaTags: {
        title: "Communication Details"
      }
    }
  },
  {
    path: "/admin/communications/bulk/activities",
    component: () =>
      import(
        /* webpackChunkName: "communication" */ "@/views/admin/communication/Activities/CommunicationAllActivities.vue"
      ),
    meta: {
      breadcrumbs: [
        {
          link: "/admin/communications",
          title: "Communications"
        }
      ],
      pageTitle: "Communication Activities",
      requireAuth: true,
      allowedRoles,
      metaTags: {
        title: "Communication Activities"
      }
    },
    name: "CommunicationActivities"
  }
];
